export default {
  paperAnchorDockedLeft: {
    borderRightWidth: 0,
  },
};
